import { useCallback, useEffect, useState } from 'react';
import { useAlert, fetchAppointmentForClinicalNotes } from '@uplift/ui-v2';
import { ClinicalNotesContextStateType } from '../clinical-notes.context';
import { useDiagnoses } from './use-diagnoses.hook';
import { usePreviousSession, useSession } from './use-session.hook';
import { useTreatments } from './use-treatments.hook';


export const useClinicalNotes = (appointmentId: string, dispatch: ClinicalNotesContextStateType['dispatch']) => {
  const alert = useAlert();
  const [ initialLoad, setInitialLoad ] = useState(true);
  const { fetchDiagnoses } = useDiagnoses();
  const { fetchSession } = useSession();
  const { fetchPreviousSession } = usePreviousSession();
  const { fetchTreatments } = useTreatments();

  const fetchAll = useCallback(async () => {
    const appointment = await fetchAppointmentForClinicalNotes(appointmentId);

    if (!appointment) {
      alert.error('There was an error fetching the session');
      return;
    }
    const sessionResource = await fetchSession(appointmentId);

    if (!sessionResource) {
      alert.error('There was an error fetching the session');
      return;
    }
    const previousSessionResource = await fetchPreviousSession(sessionResource?.session?.id);

    const diagnoses = await fetchDiagnoses();
    const treatments = await fetchTreatments();

    dispatch({
      type: 'init',
      payload: {
        appointment,
        diagnoses,
        treatments,
        sessionResource,
        previousSessionResource,
      }
    });
    setInitialLoad(false);
  }, [ appointmentId, fetchDiagnoses, fetchTreatments, fetchSession, fetchPreviousSession, dispatch, alert ]);

  useEffect(() => {
    fetchAll();
  }, [ fetchAll ]);

  return { loading: initialLoad };
};
